import './roof-angle-orientation.component.css';

export const RoofAngleOrientationSlide = ({
    orientation,
    inclination,
    onOrientationInclinationChange,
    onContinue
}: {
    orientation: string | null;
    inclination: number | null;
    onOrientationInclinationChange: (orientation: string | null, inclination: number | null) => void;
    onContinue: () => void;
}) => {
    // Constants
    const orientationOptions = ['N', 'NE', 'E', 'SE', 'S', 'SO', 'O', 'NO'];
    const inclinationOptions = [{
        value: 0,
        icon: (color: string) =>
            <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="4px" viewBox="0 0 40 4">
                <g>
                    <rect x="0" y="0" width="40" height="4" fill={color} />
                </g>
            </svg>
    }, {
        value: 10,
        icon: (color: string) => 
            <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="10px" viewBox="0 0 40 8">
                <g>
                    <polyline fill="none" stroke={color} strokeWidth="3" strokeMiterlimit="10" points="0,8 20,0 40,8" />
                </g>
            </svg>
    },{
        value: 20,
        icon: (color: string) => 
            <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="11.5px" viewBox="0 0 40 11.5">
                <g>
                    <polyline fill="none" stroke={color} strokeWidth="3" strokeMiterlimit="10" points="0,11.5 20,1.5 40,11.5" />
                </g>
            </svg>
    }, {
        value: 35,
        icon: (color: string) => 
            <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="16px" viewBox="0 0 40 16">
                <g>
                    <polyline fill="none" stroke={color} strokeWidth="3" strokeMiterlimit="10" points="0,16 20,1.5 40,16" />
                </g>
            </svg>
    }];

    return (<div className="row roof-angle-orientation">
        <div className="col-6">
            <h2>
                Necesitamos conocer <span className="inverted">la inclinación 
                y orientación</span> de tu tejado.
            </h2>
            <hr className="separator green-gradient"></hr>
            <p className="p-large">
                Así podremos adaptar nuestros paneles para 
                que reciban <strong>la máxima radiación solar.</strong>
            </p>
            <button className={`fake-input${orientation === null || inclination === null ? ' active' : ''} button`} onClick={() => {
                onOrientationInclinationChange(null, null);
                onContinue();
            }}>
                No lo sé
            </button>
            <button onClick={() => { onContinue(); }} className="button">
                Continuar
            </button>
        </div>
        <div className="col-5">
            {
                orientationOptions.map((option, i) => 
                    <button
                        key={`roof-orientation-options--option--${i}`} 
                        className={`roof-orientation-options--option${orientation === option ? ' selected' : ''}`}
                        onClick={() => { onOrientationInclinationChange(option, inclination); }}
                    >
                        {option}
                    </button>
                )
            }
            <h4>Orientación:</h4>
            <img className="compass" src={require('../../assets/compass.png')} alt="Brújula" />
        </div>
        <div className="col-1">
            <h4>Inclinación:</h4>
            <div className="roof-angle-options">
                {
                    inclinationOptions.map(({ icon, value }, i) => 
                        <button
                            key={`roof-angle-options--option--${i}`}
                            className={`roof-angle-options--option${inclination === value ? ' selected' : ''}`}
                            onClick={() => {  onOrientationInclinationChange(orientation, value); }}
                        >
                            {icon(inclination === value ? '#FFFFFF' : '#81B9C6')} {value}°
                        </button>
                    )
                }
            </div>
        </div>
    </div>);
}